document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initMarquesina();
  initTono();
  initFaq();
});

function initReveal() {
  const els = document.querySelectorAll('.lu-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('lu-visible'));
    return;
  }
  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.luDelay || 0;
          setTimeout(() => entry.target.classList.add('lu-visible'), Number(delay));
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );
  els.forEach((el) => obs.observe(el));
}

function initContadores() {
  const els = document.querySelectorAll('[data-lu-contador]');
  if (!els.length) return;
  const anima = (el) => {
    const fin = parseFloat(el.dataset.luContador);
    const dur = 1500;
    const inicio = performance.now();
    function paso(ahora) {
      const p = Math.min((ahora - inicio) / dur, 1);
      el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3))).toLocaleString('es-MX');
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  };
  if (!('IntersectionObserver' in window)) { els.forEach((el) => (el.textContent = el.dataset.luContador)); return; }
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { anima(entry.target); obs.unobserve(entry.target); }
    });
  }, { threshold: 0.6 });
  els.forEach((el) => obs.observe(el));
}

function initMarquesina() {
  document.querySelectorAll('[data-lu-marquesina]').forEach((track) => {
    if (track.dataset.luCloned) return;
    track.dataset.luCloned = '1';
    track.innerHTML += track.innerHTML;
  });
}

/* Demostrador de tono e intensidad de la luz */
function initTono() {
  document.querySelectorAll('[data-lu-tono]').forEach((wrap) => {
    const foto = wrap.querySelector('[data-lu-tono-foto]');
    const imgs = wrap.querySelectorAll('.lu-tono__img');
    const botones = wrap.querySelectorAll('[data-lu-tono-btn]');
    const rango = wrap.querySelector('[data-lu-tono-rango]');
    const nombre = wrap.querySelector('[data-lu-tono-nombre]');
    const pct = wrap.querySelector('[data-lu-tono-pct]');
    if (!foto) return;
    const aplicar = () => {
      const activo = wrap.querySelector('[data-lu-tono-btn].is-activo') || botones[0];
      const idx = activo ? Number(activo.dataset.index) : 0;
      const nivel = rango ? Number(rango.value) : 70;
      imgs.forEach((im, i) => im.classList.toggle('is-activa', i === idx));
      foto.style.setProperty('--lu-nivel', (nivel / 100).toString());
      if (nombre && activo) nombre.textContent = activo.dataset.nombre;
      if (pct) pct.textContent = nivel + '%';
    };
    botones.forEach((b) => b.addEventListener('click', () => {
      botones.forEach((x) => x.classList.remove('is-activo'));
      b.classList.add('is-activo');
      aplicar();
    }));
    if (rango) rango.addEventListener('input', aplicar);
    aplicar();
  });
}

function initFaq() {
  document.querySelectorAll('.lu-faq__item').forEach((d) => {
    d.addEventListener('toggle', () => {
      if (!d.open) return;
      d.parentElement.querySelectorAll('.lu-faq__item[open]').forEach((o) => { if (o !== d) o.open = false; });
    });
  });
}
